import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Stack, Button, Paper } from "@mui/material";
import { useTranslate, useLogin, useNotify } from "react-admin";
import { Avatar, IconButton, InputAdornment, TextField } from "@mui/material";
import { Lock, Visibility, VisibilityOff } from "@mui/icons-material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const schema = yup.object({
  email: yup.string().email("E-mail inválido").required("Campo obrigatório"),
  password: yup.string().required("Campo obrigatório"),
});

const Login = () =>
{
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const translate = useTranslate();
  const notify = useNotify();
  const login = useLogin();

  const handleClickShowPassword = () =>
  {
    setShowPassword(!showPassword);
  };

  const onSubmit = (data) =>
  {
    setLoading(true);
    login(data).catch(() =>
    {
      setLoading(false);
      notify("E-mail ou senha inválido!", { type: "error" });
    });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
        py: 3,
        background: "linear-gradient(180deg, #f6fbf9 0%, #eff5f2 100%)",
      }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 3,
          p: { xs: 3, sm: 4 },
          borderColor: "rgba(0,0,0,0.08)",
        }}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Stack spacing={3}>
            <Stack
              spacing={1}
              sx={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}>
              <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48, mx: "auto" }}>
                <Lock />
              </Avatar>
              <Typography variant="h6" fontWeight={600} sx={{ width: "100%", textAlign: "center" }}>
                Faça o login
              </Typography>
            </Stack>

            <Stack spacing={2}>
              <TextField
                autoFocus
                {...register("email")}
                fullWidth
                disabled={loading}
                label={translate("ra.auth.email")}
                error={!!errors.email}
                helperText={errors.email ? errors.email.message : " "}
                sx={{ "& .MuiOutlinedInput-root": { minHeight: 48 } }}
              />

              <TextField
                id="password"
                {...register("password")}
                fullWidth
                type={showPassword ? "text" : "password"}
                disabled={loading}
                label={translate("ra.auth.password")}
                error={!!errors.password}
                helperText={errors.password ? errors.password.message : " "}
                sx={{ "& .MuiOutlinedInput-root": { minHeight: 48 } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>

            <Button
              color="primary"
              type="submit"
              fullWidth
              disabled={loading}
              sx={{ minHeight: 48, fontWeight: 700 }}>
              Entrar
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
};

Login.propTypes = {
  authProvider: PropTypes.func,
  previousRoute: PropTypes.string,
};

export default Login;
